var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{key:_vm.unique,ref:"canvas",attrs:{"width":_vm.width,"height":_vm.height},on:{"click":_vm.refresh}})}
var staticRenderFns = []

export { render, staticRenderFns }